import { FunctionComponent } from "react"
import clsx from "clsx"
import Image from "next/legacy/image"
import Link from "next/link"
import S from "./product-box.module.scss"
import CartIcon from "../svgs/cart.svg"
import { getProductUrl } from "@/lib/product"
import { Product } from "@/types"

type ProductBoxProps = {
  data: Product
  className?: string
}

const ProductBox: FunctionComponent<ProductBoxProps> = ({
  data,
  className,
}) => {
  return (
    <div className={clsx(S.box, className)}>
      <Link href={getProductUrl(data)} className="stretched-link">
        <Image
          src={data.image_url || "/images/placeholder-image-box.svg"}
          alt={data.product_title}
          width={270}
          height={220}
          layout="responsive"
          quality="100"
        />
      </Link>
      <div className={S.inner}>
        <p className={S.name}>{data.product_title}</p>
      </div>
      <div className={S.meta}>
        <div className="row align-items-center">
          <div className="col">
            <p className={S.code}>{data.item_number}</p>
          </div>
          <div className="col-auto">
            <Link
              href={getProductUrl(data)}
              className={clsx(S.cart, "d-flex align-items-center")}
            >
              <CartIcon className={S.cartIcon} />
              <p className={S.cartText}>Add to Cart</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductBox
